/**
 * 统一客户管理路由
 * 基于动态客户类型的新版客户管理
 */

// 导入RouterView组件
import { RouterView } from 'vue-router';
import { h } from 'vue';

// 创建临时页面组件
const TemporaryPage = {
  name: 'TemporaryPage',
  render() {
    return h('div', { style: { padding: '50px', textAlign: 'center' } }, [
      h('div', { class: 'a-result a-result-info' }, [
        h('div', { class: 'a-result-icon a-result-info' }, [
          h('span', { class: 'anticon anticon-info-circle' })
        ]),
        h('div', { class: 'a-result-title' }, '页面开发中'),
        h('div', { class: 'a-result-subtitle' }, '该页面正在开发中，敬请期待...'),
        h('div', { class: 'a-result-extra' }, [
          h('button', {
            class: 'a-button a-button-primary',
            onClick: () => window.history.back()
          }, '返回')
        ])
      ])
    ]);
  }
};

const UnifiedCustomerRoutes = {
  path: '/',
  component: RouterView,
  meta: {
    title: '客户管理',
    icon: 'team',
    order: 3
  },
  children: [
    {
      path: '/unified-customer',
      name: 'UnifiedCustomerManagement',
      component: () => import('@/views/unified-customer-management/list'),
      meta: {
        title: '统一客户管理',
        icon: 'team'
      }
    },
    {
      path: '/unified-customer/detail/:id',
      name: 'UnifiedCustomerDetail',
      component: () => import('@/views/unified-customer-management/detail'),
      meta: {
        title: '客户详情',
        icon: 'profile',
        activeMenu: '/unified-customer',
        hideInMenu: true
      }
    },
    {
      path: '/unified-customer/create',
      name: 'UnifiedCustomerCreate',
      component: () => import('@/views/unified-customer-management/create'),
      meta: {
        title: '新建客户',
        icon: 'plus',
        activeMenu: '/unified-customer',
        hideInMenu: true
      }
    },
    {
      path: '/unified-customer/edit/:id',
      name: 'UnifiedCustomerEdit',
      component: () => import('@/views/unified-customer-management/edit'),
      meta: {
        title: '编辑客户',
        icon: 'edit',
        activeMenu: '/unified-customer',
        hideInMenu: true
      }
    },
    {
      path: '/unified-customer/type-management',
      name: 'CustomerTypeManagement',
      component: () => import('@/views/unified-customer-management/customer-type-management'),
      meta: {
        title: '客户类型管理',
        icon: 'appstore',
        activeMenu: '/unified-customer',
        hideInMenu: true
      }
    }
  ]
};

export default UnifiedCustomerRoutes; 